export default __webpack_public_path__ + "static/bakelit-2c00c8ddc2e153b7e26e71a58bee5b97.jpg";